import Header from "./header/Header";
import Footer from "./footer/Footer";
import { Outlet } from "react-router-dom";
import ScrollUp from "../components/utility/scrollUp/ScrollUp";

export default function MainLayout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
      <ScrollUp />
    </>
  );
}
